import moment from 'moment';

export function FromNowFilter(restaurantHoursService) {
    'ngInject';
    return function(momentObject) {
        let initial = restaurantHoursService.data.initialMoment;
        let resultString = '';
        if (moment.isMoment(momentObject)) {
            var msDiff = momentObject.diff(initial, 'minutes'),
                diff = moment.duration(Math.ceil(msDiff / 5) * 5, 'minutes');
            let days = diff.days();
            let hours = diff.hours();
            let minutes = diff.minutes();
            let asDays = Math.round(diff.asDays());

            if(asDays >= 1) {
                resultString = asDays + ' day' + (asDays > 1 ? 's' : '');
            } else {
                if(days > 0) {
                    resultString = days + ' day';
                }
                if(hours > 0) {
                    resultString += ' ' + hours + ' hour' + (hours > 1 ? 's' : '');
                }
                if(minutes > 0) {
                    resultString += ' ' + minutes + ' minute' + (minutes > 1 ? 's' : '');
                }
                if(resultString === '') {
                    resultString = 'a moment';
                }
            }

        }
        return resultString.trim();
    };
}
